class ContratoPerfilIcmsModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'perfilIcms' ]

  constructor: ($injector, @modalInstance, @perfilIcms) ->
    super($injector)

angular.module("eficienciaFiscalModule").controller('contratoPerfilIcmsModalController', ContratoPerfilIcmsModalController)